import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import Signal from "badmfck-signal";
import "./index.css";

const bootstrap = async () => {
	await import(/* @vite-ignore */ `${import.meta.env.BASE_URL}app-config.js`);

	const [{ default: App }, { AuthService }, { HTTP }, { FaqService }, { ChatService }] = await Promise.all([
		import("./App"),
		import("./services/AuthService"),
		import("./services/HTTP"),
		import("./services/FaqService"),
		import("./services/ChatService"),
	]);

	Signal.setupReact(useState, useEffect);
	new HTTP();
	new AuthService();
	new FaqService();
	new ChatService();

	ReactDOM.createRoot(document.getElementById("root")!).render(
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
};

void bootstrap();
